module.exports = __webpack_public_path__ + "static/img/bocongthuong.b0f7be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bocongthuong.png
// module id = VpPv
// module chunks = 1